function emptyStringToUndefined(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return undefined;
  }
  return value;
}

export { emptyStringToUndefined };


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/EmptyStringToUndefined.js